const midRouter = (store) => (next) => (action) => {
  //NavigationActions.navigate("login"),
  // console.log("Middleware triggereds:", action);
  next(action);
};

export default midRouter;
